const postCardStyle = (theme) => ({
  postCardContainer: {
    maxWidth: 375,
    marginBottom: 18,
    position: "relative",
    backgroundColor: "white",
    borderRadius: 3,
    overflow: "hidden",
    cursor: "pointer",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      marginLeft: "auto",
      marginRight: "auto",
    },
    [theme.breakpoints.up("sm")]: {
      width: "49%",
    },
    transition: "all .5s ease",
    boxShadow: "0px 0px 9px 0px rgba(0,0,0,0.6)",
    "&:hover": {
      boxShadow: "0 9px 9px 0px rgba(0, 0, 0, 0.6)",
      transform: "scale(1.03, 1.03)",
    },
  },
  link: {
    textDecoration: "none",
  },
  postImg: {
    width: "100%",
  },
  postCardTitle: {
    paddingTop: 0,
    paddingBottom: 18,
    paddingRight: 3,
    paddingLeft: 3,
    fontSize: 15,
    color: "black",
  },
  postCardDate: {
    position: "absolute",
    bottom: 0,
    right: 3,
    padding: 3,
    fontSize: 12,
    color: "#cccccc",
  },
});
export default postCardStyle;
